import { myAxios } from "./axios";

export function getBusinessCategories(payload, { page, limit }) {
    let config = {
        params: {
            page,
            limit,
            ...(payload || {}),
        },
    };
    return myAxios.get("/business-categories", config);
}

export function getBusinessCategory(id) {
    return myAxios.get("/business-categories/" + id);
}

export function addBusinessCategory(data) {
    return myAxios.post("/business-categories/", data);
}

export function editBusinessCategory(id, data) {
    return myAxios.put("/business-categories/edit/" + id, data);
}

export function deleteBusinessCategory(id) {
    return myAxios.delete("/business-categories/" + id);
}
